// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-team img[data-v-186eb662]{width:60px;height:60px}.horizontal-full-width[data-v-186eb662]{grid-template-columns:repeat(1,1fr)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
